<template>
  <div>
    <ballistics-params-view
      v-if="groupId === groupIds.BALLISTICS"
      :has-realizations="hasRealizations"
      :sets="sets"
    />
    <cardio-params-view
      v-else-if="groupId === groupIds.CARDIO"
      :has-realizations="hasRealizations"
      :sets="sets"
    />
    <endurance-params-view
      v-else-if="groupId === groupIds.ENDURANCE"
      :has-realizations="hasRealizations"
      :sets="sets"
    />
    <football-params-view
      v-else-if="groupId === groupIds.FOOTBALL"
      :has-realizations="hasRealizations"
      :sets="sets"
    />
    <plyometrics-params-view
      v-else-if="groupId === groupIds.PLYOMETRICS"
      :has-realizations="hasRealizations"
      :sets="sets"
    />
    <speed-params-view
      v-else-if="groupId === groupIds.SPEED"
      :has-realizations="hasRealizations"
      :sets="sets"
    />
    <strength-params-view
      v-else-if="groupId === groupIds.STRENGTH"
      :has-realizations="hasRealizations"
      :sets="sets"
    />
    <mobility-params-view
      v-else-if="groupId === groupIds.MOBILITY"
      :has-realizations="hasRealizations"
      :sets="sets"
    />
    <div
      v-if="params.TEXDR"
      class="align-center mb-2"
    >
      <div
        class="grey--text text--darken-1 d-inline-block text-body-1"
        style="width: 50px"
      >
        {{ $t('individual_analysis.training_exercise.group_card.total') }}
      </div>

      <exercise-param-label-helper
        :label="$t('training_builder.text_input.duration.title')"
        :param="params.TEXDR"
        suffix="min"
      />
    </div>
  </div>
</template>
<script>
import BallisticsParamsView from '@/components/training-builder/ballistics/BallisticsParamsView.vue'
import SpeedParamsView from '@/components/training-builder/speed/SpeedParamsView.vue'
import FootballParamsView from '@/components/training-builder/football/FootballParamsView.vue'
import StrengthParamsView from '@/components/training-builder/strength/StrengthParamsView.vue'
import CardioParamsView from '@/components/training-builder/cardio/CardioParamsView.vue'
import PlyometricsParamsView from '@/components/training-builder/plyometrics/PlyometricsParamsView.vue'
import EnduranceParamsView from '@/components/training-builder/endurance/EnduranceParamsView.vue'
import { TrainingExerciseGroupId } from '@/data/models/TrainingExercise'
import MobilityParamsView from '@/components/training-builder/mobility/MobilityParamsView.vue'
import ExerciseParamLabelHelper from '@/components/training-builder/ExerciseParamLabelHelper.vue'

export default {
  name: 'ExerciseParamsViewTemplate',
  components: {
    ExerciseParamLabelHelper,
    MobilityParamsView,
    EnduranceParamsView,
    PlyometricsParamsView,
    CardioParamsView,
    StrengthParamsView,
    FootballParamsView,
    SpeedParamsView,
    BallisticsParamsView
  },
  props: {
    groupId: {
      type: String,
      required: true
    },
    params: {
      type: Object,
      required: true
    },
    sets: {
      type: Array,
      required: true
    },
    hasRealizations: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.groupIds = TrainingExerciseGroupId
  }
}
</script>
